<template>
    <div class="gap-2 grid">
        <input ref="inputRef" type="text" :value="formattedValue"
            :class="cn(
                'file:text-foreground placeholder:text-muted-foreground selection:bg-primary selection:text-primary-foreground dark:bg-input/30 border-input flex h-9 w-full min-w-0 rounded-md border bg-transparent px-3 py-1 text-base shadow-xs transition-[color,box-shadow] outline-none file:inline-flex file:h-7 file:border-0 file:bg-transparent file:text-sm file:font-medium disabled:pointer-events-none disabled:cursor-not-allowed disabled:opacity-50',
                'focus-visible:border-ring focus-visible:ring-ring/50 focus-visible:ring-[3px]',
                'aria-invalid:ring-destructive/20 dark:aria-invalid:ring-destructive/40 aria-invalid:border-destructive')" placeholder="£20"></input>
        <div v-if="errorMessage" class="text-destructive-foreground text-sm">{{ errorMessage }}</div>
    </div>
</template>
<script lang="ts" setup>
import { useCurrencyInput } from 'vue-currency-input'
import { ICurrencyInputProps } from './CurrencyInput.model';
import { watch } from 'vue';
import { useField } from 'vee-validate';
import { cn } from "@/lib/utils"

const props = defineProps<ICurrencyInputProps>()



const { inputRef, setValue, numberValue, formattedValue } = useCurrencyInput({
    ...props.options,

})

const { errorMessage, handleChange, value } = useField(props.name);

watch(numberValue, (newValue) => {
    handleChange(newValue);
});

watch(
    value,
    (newValue) => {
        if (newValue !== numberValue.value) {
            setValue(newValue as number);
        }
    },
    { immediate: true }
);
</script>